
import { useEventContext, useUserContext } from 'contexts';
import { insertQuiz } from 'graphql/mutations';
import { InsertQuiz, InsertQuizVariables } from 'graphql/mutations/types/InsertQuiz';
import { useMutation } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';
import { NavPages, NavUtils } from 'utils';
import { EditQuiz, useSnackbar } from 'components';
import { Quiz } from 'types';

export const CreateQuiz = () => {
    const event = useEventContext();
    const user = useUserContext();
    const navigate = useNavigate()
    const snackbar = useSnackbar();
    const { eventAlias } = useParams();

    const onQuizCreated = (data: InsertQuiz) => {
        if (!data.insert_quiz_master_quizzes || data.insert_quiz_master_quizzes?.returning.length === 0){
            snackbar.error('Failed to create quiz. Please refresh and try again.')
            return;
        }

        if (data.insert_quiz_master_quizzes?.returning.length > 1){
            snackbar.success('Quiz created')
            return;
        }

        navigate(NavUtils.generateNavPath(NavPages.EditQuiz, data.insert_quiz_master_quizzes?.returning[0].id, event?.alias));
    }

    const [
        insertQuizMutation
    ] = useMutation<InsertQuiz, InsertQuizVariables>(insertQuiz,{
        onCompleted: onQuizCreated
    });

    if (!user.isEventCreatorRole(eventAlias)) {
        navigate(NavUtils.generateNavPath(NavPages.Root, undefined, event?.alias))
        return null;
    }


    const onSaveQuiz = async (quiz: Quiz) => {
        if (!user?.id) {
            snackbar.error('Failed to create quiz. Missing author user.')
            return;
        }

        await insertQuizMutation({
            variables: {
                ...quiz,
                authorUserId: user.id,
            }
        })
    };

    return (
        <div className="aq-content">
            <h2>Create Quiz</h2>
            <EditQuiz onSaveQuiz={onSaveQuiz} />
        </div>
    );
};
